export const updateState = (oldState, newValues) => {
  return {
    ...oldState,
    ...newValues
  };
};

export const cloneObject = (oldObject, newObject) => {
  // Only merges items in the oldObject that match in the newObject (perfect for states
  // that don't need all the extra merge fluff).
  let updatedObject = {};

  for(const key in oldObject) {
    if (oldObject[key] !== null && typeof oldObject[key] === 'object') {
      if (newObject && key in newObject) {
        updatedObject[key] = cloneObject(oldObject[key], newObject[key]);
      }
    } else {
      if (newObject && key in newObject) {
        updatedObject[key] = newObject[key];
      }
    }
  }

  return updatedObject;
};